export type SavedCard = {
  readonly id: string;
  readonly creditCardBrand: string;
  readonly creditCardNumber: string;
  readonly holderName: string;
  readonly isPrimary: boolean;
};


export function getCardRowClass({ isSelected }: { isSelected: boolean }): string {
  return isSelected
    ? 'flex w-full items-center gap-4 rounded-xl border border-secondary bg-secondary/5 p-4 text-left transition'
    : 'flex w-full items-center gap-4 rounded-xl border border-slate-200 bg-white p-4 text-left transition hover:bg-slate-50';
}

export function getRadioClass({ isSelected }: { isSelected: boolean }): string {
  return isSelected
    ? 'h-4 w-4 flex-shrink-0 rounded-full border-2 border-secondary bg-secondary'
    : 'h-4 w-4 flex-shrink-0 rounded-full border-2 border-slate-300';
}
